const initialState = {
  userContactData: {},
  ticketData: {},
  verificationData: {},
  eventData: {},
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'SELL_TICKET:USER_CONTACT:SET':
    return {
      ...state,
      userContactData: data,
    };
  case 'SELL_TICKET:TICKET_DATA:SET':
    return {
      ...state,
      ticketData: data,
    };
  case 'SELL_TICKET:VERIFICATION_DATA:SET':
    return {
      ...state,
      verificationData: data,
    };
  case 'SELL_TICKET:EVENT_DATA:SET':
    return {
      ...state,
      eventData: data,
    };
  default:
    return state;
  }
};
